module.exports = __webpack_public_path__ + "static/Firewatch3-723ae1b95211b871fad59eae35d3b4b3.webp";